export default "__VITE_ASSET__Dct$qtNb__"